import { PlayingCamerasController } from 'components/VideoPlayer/controller/PlayingCamerasController';
import React, { useContext } from 'react';
import { useLocalController } from 'solox';

const PlayingCamerasContext = React.createContext<PlayingCamerasController | undefined>(undefined);

export const PlayingCamerasProvider: React.FC<{ children: React.ReactNode }> = (props) => {
  const playingCamerasController = useLocalController(() => new PlayingCamerasController(true));
  return (
    <PlayingCamerasContext.Provider value={playingCamerasController}>
      {props.children}
    </PlayingCamerasContext.Provider>
  );
};

export function usePlayingCamerasContext() {
  const playingCamerasController = useContext(PlayingCamerasContext);
  if (!playingCamerasController) {
    throw new Error(`Missing PlayingCamerasProvider`);
  }
  return playingCamerasController;
}
